import {
  getFestivalCountriesAction,
  getFestivalsAction,
  getFestivalYearsAction,
  searchFestivalsAction,
  getFestivalsProductionsAction,
  clearFestivalsOptionsAction,
} from './actions';
import { defaultListParams, listReducer, namedListParams } from '../../utils/crudUtils';

export const key = 'Festivals';

export const initialState = {
  countries: defaultListParams,
  festivals: namedListParams('festivals'),
  years: defaultListParams,
  searchFestivalsList: defaultListParams,
  festivalProductions: namedListParams('festivalProductions'),
};

const festivalsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case getFestivalsAction.TRIGGER:
    case getFestivalsAction.SUCCESS:
    case getFestivalsAction.FAILURE:
      return listReducer(state, type, payload, initialState.festivals.listName);

    case getFestivalYearsAction.TRIGGER:
    case getFestivalYearsAction.SUCCESS:
    case getFestivalYearsAction.FAILURE:
      return listReducer(state, type, payload, 'years');

    case getFestivalCountriesAction.TRIGGER:
    case getFestivalCountriesAction.SUCCESS:
    case getFestivalCountriesAction.FAILURE:
      return listReducer(state, type, payload, 'countries');

    case searchFestivalsAction.TRIGGER:
    case searchFestivalsAction.SUCCESS:
    case searchFestivalsAction.FAILURE:
      return listReducer(state, type, payload, 'searchFestivalsList');

    case getFestivalsProductionsAction.TRIGGER:
    case getFestivalsProductionsAction.SUCCESS:
    case getFestivalsProductionsAction.FAILURE:
      return listReducer(state, type, payload, initialState.festivalProductions.listName);

    case clearFestivalsOptionsAction.TRIGGER:
      return { ...state, searchFestivalsList: defaultListParams };

    default:
      return state;
  }
};

export default festivalsReducer;
